import { AnimatePresence, motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

interface InstallBannerProps {
  onInstall: () => void;
  onDismiss: () => void;
}

export function InstallBanner({ onInstall, onDismiss }: InstallBannerProps) {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="fixed bottom-0 inset-x-0 z-40 border-t border-[#CAC7C7] bg-[#F4F2F2]/95 backdrop-blur-md shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
        role="banner"
        aria-label={t('pwa.title')}
      >
        <div className="max-w-4xl mx-auto px-4 py-4 sm:px-8 sm:py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <Download className="w-5 h-5 text-[#E94E1B] mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-[#2E2A23] mb-1">{t('pwa.title')}</p>
                <p className="text-xs text-[#888185] leading-relaxed">{t('pwa.description')}</p>
              </div>
            </div>
            <div className="flex gap-2 w-full sm:w-auto flex-shrink-0">
              <Button variant="ghost" size="sm" onClick={onDismiss} className="flex-1 sm:flex-none">
                {t('pwa.dismiss')}
              </Button>
              <Button
                variant="primary"
                size="sm"
                onClick={onInstall}
                className="flex-1 sm:flex-none"
              >
                {t('pwa.install')}
              </Button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
